@if (canShow) {
  <button
    mat-menu-item
    (click)="onAdd()"
    >
    <mat-icon color="success">add</mat-icon>
    <span>Add Products</span>
  </button>
}
